<template>
    <div class="grid">
        <div class="column w-full md:w-1/2">
            <select-input
                v-model="selectedTeam"
                :options="availableTeams"
                name="team_id"
                placeholder="Välj team"
                class="mb-0"
            />
        </div>
        <div class="column w-full mt-lg md:w-1/2 md:mt-0">
            <select-input
                v-if="selectedTeam"
                v-model="selectedSalesPeriod"
                :options="salesPeriodsAsOptions"
                name="sales_period_id"
                placeholder="Alla säljomgångar"
                class="mb-0"
            />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            initialSelectedTeam: {
                type: String,
                default: '',
            },
            availableTeams: {
                required: true,
                type: Object,
            },
            availableSalesPeriods: {
                required: true,
                type: Array,
            },
        },
        data() {
            return {
                selectedTeam: this.initialSelectedTeam,
                selectedSalesPeriod: '',
            };
        },
        computed: {
            salesPeriodsForSelectedTeam() {
                return this.availableSalesPeriods
                    .filter((period) => {
                        return period.team_id === parseInt(this.selectedTeam);
                    });
            },
            salesPeriodsAsOptions() {
                return this.salesPeriodsForSelectedTeam
                    .reduce((salesPeriodsAsOption, period) => {
                        salesPeriodsAsOption[period.id] = period.name;
                        return salesPeriodsAsOption;
                }, {});
            },
        },
        watch: {
            selectedTeam() {
                this.selectedSalesPeriod = '';
            },
        },
    };
</script>
